import { defineStore } from 'pinia';
import { fetchStructures } from '@/api';

export default defineStore({
  id: 'structures',

  state: () => {
    return {
      list: [],
      listPage: {},
    };
  },

  getters: {},

  actions: {
    async getItems(parentId, recursive = true, withActiveAlerts = true) {
      const params = { parentId, recursive, withActiveAlerts };
      const { structures, meta } = await fetchStructures(params);

      this.list = structures;
      this.listPage = meta;
    },
  },
});
